<div class="footer-container" *ngIf="loginError">
  <div class="row">
    <div class="d-flex justify-content-center shadow">

    </div>
  </div>
</div>
